import React, { useEffect, useState } from 'react'
import { roleValidationForm } from '../../utils/validationSchema';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import Form from '../../layouts/Form';
import RoleForm from './RoleForm';

const UpdateRole = (props: any) => {
  const { handleEdit, isLoading, refetch, userPermissions } = props;
  const [selectedPermission, setSelectedPermission] = useState([])
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(roleValidationForm),
    defaultValues: async () => {
      let data: any = await refetch()
      setSelectedPermission([...data?.data?.custom_permissions])
      return {
        role: data?.data?.group_name
      }
    }
  });

  useEffect(() => {
    setValue("custom_permissions", selectedPermission)
  }, [selectedPermission])

  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <RoleForm
        selectedUserPermissions={selectedPermission}
        userPermissions={userPermissions}
        errors={errors}
        register={register}
        setSelectedPermission={setSelectedPermission}
      />
    </Form>
  );
}

export default UpdateRole